module.exports = "/images/blockIcon.svg?6243a0b15ecdfee02d6b80ab7bf749e5";